import classNames from 'clsx';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import CashIcon from '@swf/core/assets/casino/cash-cricle.svg';
import IBIcon from '@swf/core/assets/casino/instant-bonus.svg';
import type { InstantBonus } from '@swf/core/types/InstantBonus';
import { isActive } from '@swf/core/utils/casino';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import sharedStyles from '../InstantBonusSharedTile.scss';

import styles from './WagerBonus.scss';
import WagerIcon from './components/WagerIcon';

interface Props {
  ib: InstantBonus;
  compact?: boolean;
}

const WagerBonus: React.FC<Props> = ({ ib, compact }) => {
  const { bonusAmount, cashAmount } = ib;

  return (
    <div
      className={classNames({
        [styles.wager]: true,
        [sharedStyles.wager]: true,
        [sharedStyles.disabled]: !isActive(ib) || ib.paused
      })}
    >
      <div>
        <CashIcon />
        <div className={classNames(sharedStyles.info)}>
          <div className={sharedStyles.price}>
            <CurrencyAmount value={cashAmount} currency={ib.currency} />
          </div>
        </div>
      </div>
      <span className={styles.plus}>+</span>
      <div>
        <IBIcon />
        <div className={classNames(sharedStyles.info)}>
          <div className={sharedStyles.price}>
            <CurrencyAmount value={bonusAmount} currency={ib.currency} />
          </div>
        </div>
      </div>
      <span className={styles.equal}>=</span>
      <div>
        <WagerIcon contributionRatio={ib.contributionRatio} />
        <div className={classNames(sharedStyles.info)}>
          <div className={sharedStyles.price}>
            <CurrencyAmount value={cashAmount + bonusAmount} currency={ib.currency} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WagerBonus;
